// extracted by mini-css-extract-plugin
export var navbarSubLink = "C_g2 f_g2 f_gW f_b3 f_dc f_fm f_cs f_cT";
export var menuLink = "C_vm f_gS f_fB";
export var subPageLink = "C_g6 f_g6 f_fr f_fv";
export var subPageLinkColor = "C_g7 f_g7";
export var burgerItemSmall = "C_vn f_g5 f_b2 f_ct";
export var Link = "C_tn v_tn v_sJ v_s2";